import { useLocation } from 'react-router';

import { CONVERSATIONS_PATH } from 'app/routing/routeIds';

export const useIsConversation = (): boolean => {
    const { pathname } = useLocation();
    return pathname.startsWith(CONVERSATIONS_PATH);
};
